<!--用电-->
<template>
	<div class="hpElectricityBody">
		<div class="hpElectricityTop flexCenter" :style="backImg('/huapu/searchBarTwo.png')">
			<!--搜索框-->
			<div class="searchBar flexCenter">
				<input type="text" v-model="dropDownValue" />
				<img :src="imgName('/huapu/searchFor.png')" @click="searchFor()" />
			</div>
			<p class="yearEnergyUsed">今年用气量<span style="color: red;font-size: 18px;"> {{yearPowerValue}} </span> N m³</p>
		</div>
		<div v-if="dropDownBoxShow" class="dropDownList">
			<ul class="xaUl">
				<li v-for="item in filterList" @click="dropDownItem(item)">{{item.name}}</li>
			</ul>
		</div>
		<!--用电-->
		<div class="electricityDetailed">
			<div class="todayElectricity">
				<div class="flexCenter roundDiv">
					<img :src="imgName('/huapu/comparison.png')">
					<span style="color: #e5e312;">{{day1== undefined ?'--':day1}}</span>
				</div>
				<span>今日用气量</span>
			</div>
			<!--同比环比-->
			<div class="dayYearOnYear">
				<!--同比-->
				<div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
					<div class="flexCenterColumn"><span class="tbtext">同</span><span class="tbtext">比</span></div>
					<div class="flexCenterColumn">
						<span style="color: #e5e312;">{{day3 == undefined ?'--':day3}}</span>
						<span>上月同期用气量</span>
					</div>
					<div class="flexCenterColumn">
						<span style="color: #e5e312;">
							<img v-if="day1 > day3" :src="getUpImg">
							<img v-if="day1 < day3" :src="getDownImg">
							{{day3Compare}}</span>
						<span>上月同期相比</span>
					</div>
				</div>
				<!--环比-->
				<div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
					<div class="flexCenterColumn"><span class="tbtext">环</span><span class="tbtext">比</span></div>
					<div class="flexCenterColumn"><span style="color: #e5e312;">{{day2== undefined ?'--':day2}}</span>
						<span>昨日同期用气量</span>
					</div>
					<div class="flexCenterColumn"><span style="color: #e5e312;">
							<img v-if="day1 > day2" :src="getUpImg">
							<img v-if="day1 < day2" :src="getDownImg">
							{{day2Compare}}
						</span>
						<span>上月同期相比</span>
					</div>
				</div>
			</div>
			<div class="todayElectricity">
				<div class="flexCenter roundDiv">
					<img :src="imgName('/huapu/comparison.png')">
					<span style="color: #e5e312;">{{month1== undefined ?'--':month1}}</span>
				</div>
				<span>本月用气量</span>
			</div>
			<!--同比环比-->
			<div class="dayYearOnYear">
				<!--同比-->
				<div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
					<div class="flexCenterColumn"><span class="tbtext">同</span><span class="tbtext">比</span></div>
					<div class="flexCenterColumn">
						<span style="color: #e5e312;">{{month3== undefined ?'--':month3}}</span>
						<span>上月同期用气量</span>
					</div>
					<div class="flexCenterColumn">
						<span style="color: #e5e312;">
							<img v-if="month1 > month3" :src="getUpImg">
							<img v-if="month1 < month3" :src="getDownImg">
							{{month3Compare}}
						</span>
						<span>上月同期相比</span>
					</div>
				</div>
				<!--环比-->
				<div class="tb1 flexBetween" :style="backImg('/huapu/ringFrame.png')">
					<div class="flexCenterColumn"><span class="tbtext">环</span><span class="tbtext">比</span></div>
					<div class="flexCenterColumn"><span style="color: #e5e312;">{{month2== undefined ?'--':month2}}</span>
						<span>昨日同期用气量</span>
					</div>
					<div class="flexCenterColumn">
						<span style="color: #e5e312;">
							<img v-if="month1 > month2" :src="getUpImg">
							<img v-if="month1 < month2" :src="getDownImg">
							{{month2Compare}}
						</span>
						<span>上月同期相比</span>
					</div>
				</div>
			</div>
		</div>
		<!--图形-->
		<div class="electricityGraphics">
			<!--能耗-->
			<div class="energyConsumption" :style="backImg('/huapu/column.png')">
				<vchart ref='vchartBar' themes="purple-passion" style='width: 100%;height: 100%;'></vchart>
			</div>
			<!--峰平谷-->
			<div class="pingguPeak" :style="backImg('/huapu/cake.png')">
				<vchart ref='vchartFengping' themes="purple-passion" style='width: 80%;height: 100%;'></vchart>
				<div class="fengpingDate">
					<p v-for="(item,index) in fengpingDateList" @click="indexShow=index" :style="getFengpingDateStyle(index)">{{item}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {

		},
		data() {
			return {
				dropDownValue: '',
				filterList: [],
				dropDownBoxShow: false,
				powerDateList: {},
				yearPowerValue: 0, //年用气量
				fengpingDateList: ['本日', '本月', '本年'],
				indexShow: -1,
				barOption: {
					xAxis: [{
						type: 'category',
						axisLabel: {
							textStyle: {
								color: '#fff'
							}
						},
						axisLine: {
							show: false

						},
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
							'20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'
						],
					}],
					yAxis: [{
						axisLabel: {
							textStyle: {
								color: '#fff'
							}
						},
						axisLine: {
							show: false

						},
						type: 'value',
					}],
					legend: {
						top: '125px',
						data: ['电量', '电费'],
						textStyle: {
							color: '#2e328e'
						},
						show: false,
					},
					grid: {
						height: '70%',
						width: '90%',
						left: '2%',
						right: '1%',
						bottom: '5%',
						containLabel: true
					},
					backgroundColor: '',
					series: []
				},
				vchartFengpingOption: {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b} : {c} ({d}%)"
					},
					backgroundColor: '',
					series: [{
						type: 'pie',
						radius: '55%',
						center: ['50%', '60%'],
						data: [],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]

				},
				day1: undefined, //今日用气量
				day2: undefined, //昨日用气量
				day3: undefined, //昨日同期
				month1: undefined,
				month2: undefined,
				month3: undefined,
				transformerList: [],
				dayFengping: [], //本日峰平谷数据
				monthFengping: [], //本月峰平谷数据
				yearFengping: [], //本年峰平谷数据
			}
		},
		created() {
			this.powerDate()
		},
		mounted() {
			this.filterList = copy(this.powerRoom)
			this.getDatalist()
			this.$refs.vchartBar.setData(this.barOption)
			this.$refs.vchartFengping.setData(this.vchartFengpingOption)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowReadDeviceTree() {
				//当前单位可查看虚拟设备树
				return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
			},
			powerRoom() {
				//获取配电房
				var list = treeToList(this.nowReadDeviceTree, 'next', item => {
					return item.hasOwnProperty("next")
				})
				return list.filter(item => {
					return item.devicetype == 2
				})
			},
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			upDown() {
				return value => {
					if (value > 0) {
						return this.imgName('/huapu/up.png')
					} else {
						return this.imgName('/huapu/down.png')
					}
				}
			},
			getFengpingDateStyle() {
				return index => {
					if (index == this.indexShow) {
						return {
							'color': 'white'
						}
					} else {
						return {
							'color': '#697A98'
						}
					}
				}
			},
			day2Compare() {
				return this.compareValue(this.day1, this.day2)
			},
			day3Compare() {
				return this.compareValue(this.day1, this.day3)
			},
			month2Compare() {
				return this.compareValue(this.month1, this.month2)
			},
			month3Compare() {
				return this.compareValue(this.month1, this.month3)
			},
			getUpImg() {
				return resourcesStore.getters.getResourcesByName('/huapu/down.png')
			},
			getDownImg() {
				return resourcesStore.getters.getResourcesByName('/huapu/up.png')
			},
		},
		watch: {
			dropDownValue(nv, ov) {
				this.filterList = []
				this.powerRoom.forEach(item => {
					if (item.name.indexOf(nv) > -1) {
						this.filterList.push(item)
					}
				})
			},
			powerRoom(nv, ov) {
				this.filterList = copy(this.powerRoom)
			},
			filterList(nv, ov) {
				this.transformerList = []
				this.recursiveTfr(nv)
			},
			nowUnit(nv, ov) {
				this.powerDate()
			},
			powerDateList(nv, ov) {
				var money = []
				var power = []
				if (!isempty(nv)) {
					Object.keys(nv).forEach(function(key) {
						var pw = nv[key]['总电量']
						var my = nv[key]['总电费']
						if (isNaN(parseFloat((my))) || isnull(parseFloat((my)))) {
							my = undefined
						}
						if (isNaN(parseFloat((pw))) || isnull(parseFloat((pw)))) {
							pw = undefined
						}
						money.push(my)
						power.push(pw)
					})
				}
				this.barOption.series = [{
					name: '电量',
					type: 'bar',
					data: power,
					itemStyle: {
						color: '#1491ff',
					}
				}, {
					name: '电费',
					type: 'bar',
					data: money,
					itemStyle: {
						color: '#f07901',
					}
				}]
				this.$refs.vchartBar.setData(this.barOption)
			},
			transformerList(nv, ov) {
				this.getDatalist()
			},
			dayFengping(nv, ov) {
				this.indexShow = 0
				var colorList = ['#138fff', '#f07800', '#bba8e8', '#3bcb36']
				if (!isempty(nv)) {
					nv.forEach((item, index) => {
						item.itemStyle = {
							color: colorList[index]
						}
					})
				}
				this.vchartFengpingOption.series = [{
					type: 'pie',
					radius: '55%',
					center: ['50%', '60%'],
					data: nv,
					itemStyle: {
						emphasis: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						},
					}
				}]
				this.$refs.vchartFengping.setData(this.vchartFengpingOption)
			},
			indexShow(nv, ov) {
				var dataList = []
				switch (nv) {
					case 0:
						dataList = this.dayFengping
						break;
					case 1:
						dataList = this.monthFengping
						break;
					case 2:
						dataList = this.yearFengping
						break;
					default:
						dataList = this.dayFengping
						break;
				}
				var colorList = ['#138fff', '#f07800', '#bba8e8', '#3bcb36']
				if (!isempty(dataList)) {
					dataList.forEach((item, index) => {
						item.itemStyle = {
							color: colorList[index]
						}
					})
				}
				this.vchartFengpingOption.series = [{
					type: 'pie',
					radius: '55%',
					center: ['50%', '60%'],
					data: dataList,
					itemStyle: {
						emphasis: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
				this.$refs.vchartFengping.setData(this.vchartFengpingOption)
			}
		},
		methods: {
			compareValue(a, b) {
				if (a == 0 || b == 0 || a == undefined || b == undefined) {
					return "--"
				}
				return cutDigital((a - b) / b * 100) + "%"
			},
			searchFor() {
				this.dropDownBoxShow = true
			},
			dropDownItem(item) {
				this.dropDownBoxShow = false
				this.dropDownValue = item.name
			},
			powerDate() {
				if (!isempty(this.nowUnit.id)) {
					this.powerDateList = []
					var id = this.nowUnit.id
					this.$api.powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), this.nowUnit.id, respon => {
						if (id == this.nowUnit.id) { //接口延迟时 只赋值当前的unit结果
							this.powerDateList = respon
						}
					})
				}
			},
			getLastDay(year, month) {
				var new_year = year; //取当前的年份          
				var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）          
				if (month > 12) {
					new_month -= 12; //月份减          
					new_year++; //年份增          
				}
				var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天          
				return year + '-' + new_month + '-' + (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); //获取当月最后一天日期          
			},
			recursiveTfr(item) {
				item.forEach(i => {
					if (!isempty(i.archivesTypeCode) || i.archivesTypeCode == 'Transformer') {
						this.transformerList.push(i)
					} else {
						if (!isempty(i.next)) {
							this.recursiveTfr(i.next)
						}
					}
				})
			},
			getDatalist() {
				var now = new Date()
				var nowTime = now.getTime()
				var year = now.getFullYear()
				var month = now.getMonth()
				var day = now.getDate()
				var nowZero = new Date(year, month, day).getTime()
				var deviceNos = ''
				this.transformerList.forEach((item, index) => {
					if (this.transformerList.length == index + 1) {
						deviceNos += item.no
					} else {
						deviceNos += item.no + ','
					}
				})
				//获取今年用气量
				this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, new Date(year, 0, 1).getTime(), nowTime, respon => {
					this.yearPowerValue = Number(respon)
				})
				//获取今日电量
				this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, nowZero, nowTime, respon => {
					this.day1 = Number(respon)
				})
				//获取昨日电量
				this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, nowZero - 24 * 60 * 60 * 1000, nowZero - 1, respon => {
					this.day2 = Number(respon)
				})
				//获取上个月同一天用气量，直接月份减1如果不存在就是空
				var lastMonthDate = new Date(year, month - 1, day)
				if (lastMonthDate.getMonth() != 12 && lastMonthDate.getMonth() != now.getMonth() - 1) {
					this.day3 = undefined
				} else {
					this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, lastMonthDate.getTime(), lastMonthDate.getTime() + 24 * 60 *
						60 *
						1000 - 1, respon => {
							this.day3 = Number(respon)
						})
				}
				//获取本月用气量
				this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, new Date(year, month, 1).getTime(), nowTime, respon => {
					this.month1 = Number(respon)
				})
				//获取上月用气量
				this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, new Date(year, month - 1, 1).getTime(), new Date(year, month,
						day).getTime() -
					1, respon => {
						this.month2 = Number(respon)
					}, repon => {
						this.month2 = undefined
					})
				//获取去年同月用气量
				this.$api.powerApi.getDeviceUsePowerByDate(deviceNos, new Date(year - 1, month, 1).getTime(), new Date(this.getLastDay(
					year - 1, month + 1)).getTime(), respon => {
					this.month3 = Number(respon)
				}, respon => {
					this.month3 = undefined
				})
				/*查询设备本日峰平谷数据*/
				this.$api.powerApi.getDevicePG(deviceNos, nowZero, nowTime, respon => {
					if (!isempty(respon)) {
						this.dayFengping = [{
							name: '尖',
							value: 0
						}, {
							name: '峰',
							value: 0
						}, {
							name: '平',
							value: 0
						}, {
							name: '谷',
							value: 0
						}]
						Object.keys(respon).forEach((key, index) => {
							if (!isempty(respon[key])) {
								respon[key].forEach((item, i) => {
									if (this.dayFengping.length > i) {
										this.dayFengping[i].value = this.dayFengping[i].value + parseInt(item.value)
									}
								})
							}
						})
					}
				})
				/*查询设备本月峰平谷数据*/
				this.$api.powerApi.getDevicePG(deviceNos, new Date(year, month, 1).getTime(), nowTime, respon => {
					if (!isempty(respon)) {
						this.monthFengping = [{
							name: '尖',
							value: 0
						}, {
							name: '峰',
							value: 0
						}, {
							name: '平',
							value: 0
						}, {
							name: '谷',
							value: 0
						}]
						Object.keys(respon).forEach((key, index) => {
							if (!isempty(respon[key])) {
								respon[key].forEach((item, i) => {
									if (this.monthFengping.length > i) {
										this.monthFengping[i].value = this.monthFengping[i].value + parseInt(item.value)
									}
								})
							}
						})
					}
				})
				/*查询设备本年峰平谷数据*/
				this.$api.powerApi.getDevicePG(deviceNos, new Date(year, 0, 1).getTime(), nowTime, respon => {
					if (!isempty(respon)) {
						this.yearFengping = [{
							name: '尖',
							value: 0
						}, {
							name: '峰',
							value: 0
						}, {
							name: '平',
							value: 0
						}, {
							name: '谷',
							value: 0
						}]
						Object.keys(respon).forEach((key, index) => {
							if (!isempty(respon[key])) {
								respon[key].forEach((item, i) => {
									if (this.yearFengping.length > i) {
										this.yearFengping[i].value = this.yearFengping[i].value + parseInt(item.value)
									}
								})
							}
						})
					}
				})
				//获取本月能耗数据
				this.$api.powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), this.nowUnit.id, respon => {
					this.powerDateList = respon
				})
			}

		}
	}
</script>

<style scoped>
	.hpElectricityBody {
		width: calc(100% - 20px);
		height: calc(100% - 20px);
		margin: 10px;
		position: relative;
	}

	.hpElectricityBody span,
	.hpElectricityBody p {
		font-size: 12px;
	}

	.hpElectricityTop {
		height: 20%;
		width: 100%;
	}

	.hpElectricityTop .searchBar {
		width: 40%;
		margin-right: 20px;
	}

	.searchBar input {
		width: 100%;
		background-color: rgba(0, 0, 0, 0);
		color: white;
		border: 0;
		outline: none;
		border-bottom: .01rem solid yellow;
		border-radius: 0;
	}

	.searchBar input:focus {
		border: 0;
		outline: none;
		background-color: #143a70;
		border-bottom: .01rem solid yellow;
		border-radius: 0;
	}

	.hpElectricityTop .searchBar img {
		height: 22px;
	}

	.yearEnergyUsed {
		color: white;
		font-size: .18rem !important;
	}

	.hpElectricityBody .dropDownList {
		width: 37%;
		background-color: white;
		position: absolute;
		left: 11%;
		max-height: 40%;
		z-index: 999;
		top: 15%;
		overflow: overlay;
	}

	.hpElectricityBody .dropDownList ul li {
		padding: 0 0 .1rem .1rem;
	}

	.hpElectricityBody .dropDownList ul li:nth-child(1) {
		padding-top: .1rem;
	}

	.hpElectricityBody .dropDownList ul li:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}

	.electricityDetailed {
		width: 100%;
		padding: 5px 0;
		height: calc(40% - 10px);
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.todayElectricity {
		width: 13%;
		height: 100%;
		padding-left: .1rem;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.todayElectricity span {
		color: white;
	}

	.todayBack {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 80%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dayYearOnYear {
		display: flex;
		flex-direction: column;
		width: 30%;
		height: 100%;
		justify-content: space-between
	}

	.dayYearOnYear img {
		width: .05rem;
	}

	.tb1 {
		height: calc(50% - 10px);
		padding: 4px 10px;
	}

	.tb1 span {
		color: white;
	}

	.electricityGraphics {
		width: 100%;
		height: 40%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.energyConsumption {
		width: 60%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.pingguPeak {
		width: 40%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
	}

	.pingguPeak .fengpingDate {
		width: 10%;
		height: 100%;
	}

	.pingguPeak .fengpingDate p {
		color: #697A98;
	}

	.pingguPeak .fengpingDate p:nth-child(1) {
		padding-top: .1rem;
	}

	.roundDiv {
		width: 100%;
		height: calc(100% - 20px);
		position: relative;
	}

	.roundDiv img {
		height: 100%;
	}

	.roundDiv img,
	.roundDiv span {
		position: absolute;
	}

	.tbtext {
		color: #57ba46 !important;
		line-height: 14px;
	}
</style>
